import { combineReducers } from '@reduxjs/toolkit';
import notificationReducer from './notificationReducer';
import recintosReducer from './recintosReducer';
import usersReducer from './usersReducer';
import canchasReducer from './canchasReducer';
import serviciosReducer from './serviciosReducer';
import procedimientosReducer from './procedimientosReducer';
import tipoCanchasReducer from './tipoCanchasReducer';
import superficieReducer from './superficieReducer';
import tipoAtributosReducer from './tipoAtributosReducer';
import tipoServiciosReducer from './tipoServiciosReducer';
import atributosReducer from './atributosReducer';
import authReducer from './authReducer';
// import { reducer as calendarReducer } from 'src/slices/calendar';
// import { reducer as chatReducer } from 'src/slices/chat';
// import { reducer as formReducer } from 'redux-form';
// import { reducer as kanbanReducer } from 'src/slices/kanban';
// import { reducer as mailReducer } from 'src/slices/mail';
// import { reducer as notificationReducer } from 'src/slices/notification';

const rootReducer = combineReducers({
  notification: notificationReducer,
  recintos: recintosReducer,
  users: usersReducer,
  canchas: canchasReducer,
  servicios: serviciosReducer,
  procedimientos: procedimientosReducer,
  tipoCanchas: tipoCanchasReducer,
  superficies: superficieReducer,
  tipoAtributos: tipoAtributosReducer,
  tipoServicios: tipoServiciosReducer,
  atributos: atributosReducer,
  auth: authReducer
  // calendar: calendarReducer,
  // chat: chatReducer,
  // form: formReducer,
  // kanban: kanbanReducer,
  // mail: mailReducer,
  // notifications: notificationReducer
});

export default rootReducer;
